"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_FIELD_QUESTION = exports.getRealEstateEquityFields = exports.getRealEstateRentFields = exports.getRealEstateSaleFields = exports.getPropertyAsInvestmentFields = exports.getOtherAssetsFields = exports.getLifeInsuranceFields = exports.getCashOnHandFields = exports.getTrustAccountsFields = exports.getMutualFundsFields = exports.getStockOrBondFields = exports.getSavingsAccountFields = exports.getRetirementAccountFields = exports.getCheckingAccountFields = exports.getCertificateOfDepositFields = exports.getAssetFields = exports.DOCUMENT_UPLOAD = void 0;
var constants_1 = require("../../constants");
var AFFORDABLE_ASSET_FIELDS_1 = require("./AFFORDABLE_ASSET_FIELDS");
var CONVENTIONAL_ASSET_FIELDS_1 = require("./CONVENTIONAL_ASSET_FIELDS");
var entities_1 = require("@common/entities");
exports.DOCUMENT_UPLOAD = {
    maxFilesAllowed: '2',
    maxFilesRequired: '0',
    verifyDocumentUpload: true,
};
var getAssetFields = function (assetType, customType, isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    if (isAffordable)
        return (0, AFFORDABLE_ASSET_FIELDS_1.getAffordableAssetFields)(assetType, customType);
    return (0, CONVENTIONAL_ASSET_FIELDS_1.getConventionalAssetFields)(assetType, customType);
};
exports.getAssetFields = getAssetFields;
var getFieldStructure = function (name, label, customType, fieldKey, isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return {
        name: name,
        label: label,
        customType: customType,
        elementType: entities_1.SectionElementType.Block,
        documentUpload: exports.DOCUMENT_UPLOAD,
        fields: (0, exports.getAssetFields)(fieldKey, customType, isAffordable),
    };
};
var getCertificateOfDepositFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('certificate-of-deposit', 'Certificate of Deposit', entities_1.AssetTypes.CertificateOfDeposit, 'certificates_of_deposit', isAffordable);
};
exports.getCertificateOfDepositFields = getCertificateOfDepositFields;
var getCheckingAccountFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('checking-account', 'Checking Account', entities_1.AssetTypes.CheckingAccount, 'checking_accounts', isAffordable);
};
exports.getCheckingAccountFields = getCheckingAccountFields;
var getRetirementAccountFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('retirement-account', 'Retirement Account', entities_1.AssetTypes.RetirementAccount, 'retirement_accounts', isAffordable);
};
exports.getRetirementAccountFields = getRetirementAccountFields;
var getSavingsAccountFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('savings-account', 'Savings Account', entities_1.AssetTypes.SavingsAccount, 'savings_accounts', isAffordable);
};
exports.getSavingsAccountFields = getSavingsAccountFields;
var getStockOrBondFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    var jsonObj = getFieldStructure('stocks-or-bonds', 'Stocks Or Bonds', entities_1.AssetTypes.StocksOrBonds, 'stocks_or_bonds', isAffordable);
    var fields = jsonObj.fields;
    if (!isAffordable) {
        fields = fields === null || fields === void 0 ? void 0 : fields.filter(function (f) { return !f.name.endsWith('account_number') && !f.name.endsWith('routing_number'); });
    }
    return __assign(__assign({}, jsonObj), { fields: fields });
};
exports.getStockOrBondFields = getStockOrBondFields;
var getMutualFundsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('mutual-funds', 'Mutual Funds', entities_1.AssetTypes.MutualFunds, 'mutual_funds', isAffordable);
};
exports.getMutualFundsFields = getMutualFundsFields;
var getTrustAccountsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('trust-accounts', 'Trust Accounts', entities_1.AssetTypes.TrustAccounts, 'trust_accounts', isAffordable);
};
exports.getTrustAccountsFields = getTrustAccountsFields;
var getCashOnHandFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('cash-on-hand', 'Cash on hand or Safety Deposit Box', entities_1.AssetTypes.CashOnHand, 'cash_on_hand', isAffordable);
};
exports.getCashOnHandFields = getCashOnHandFields;
var getLifeInsuranceFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('life-insurance', 'Life Insurance', entities_1.AssetTypes.LifeInsurance, 'life_insurance', isAffordable);
};
exports.getLifeInsuranceFields = getLifeInsuranceFields;
var getOtherAssetsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('other-assets', 'Other Current Assets', entities_1.AssetTypes.OtherAssets, 'other_assets', isAffordable);
};
exports.getOtherAssetsFields = getOtherAssetsFields;
var getPropertyAsInvestmentFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('property-as-investment', 'Personal Property Held As An Investment', entities_1.AssetTypes.PropertyAsInvestment, 'property_as_investment', isAffordable);
};
exports.getPropertyAsInvestmentFields = getPropertyAsInvestmentFields;
var getRealEstateSaleFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('real-estate-sale', 'Real Estate Sale', entities_1.AssetTypes.RealEstateSale, 'real_estate_sale', isAffordable);
};
exports.getRealEstateSaleFields = getRealEstateSaleFields;
var getRealEstateRentFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('real-estate-rent', 'Real Estate Rent', entities_1.AssetTypes.RealEstateRent, 'real_estate_rent', isAffordable);
};
exports.getRealEstateRentFields = getRealEstateRentFields;
var getRealEstateEquityFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('real-estate-equity', 'Real Estate Equity', entities_1.AssetTypes.RealEstateEquity, 'real_estate_equity', isAffordable);
};
exports.getRealEstateEquityFields = getRealEstateEquityFields;
exports.ASSET_FIELD_QUESTION = [
    {
        customType: entities_1.FieldType.Radio,
        enabled: true,
        label: 'Do you have any assets?',
        name: 'assets_question',
        required: true,
        sequence: 1,
        type: entities_1.FieldType.Radio,
        options: constants_1.YES_NO_OPTIONS,
    },
];
